import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';

import { MatTableModule , MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from "@angular/common";


import { OfflineService } from '../../Shared/Services/Offline/offline.service'
import { ConfigLoaderService } from '../../Shared/Services/Config/config-loader.service';
import { FileDownloadpath, Offline } from '../../Shared/Model/offline/offline.model';

import { AuthService } from '../../Shared/Services/auth.service';
import { HttpEventType, HttpResponse, HttpClient } from '@angular/common/http';
//import { BroadcastService, MsalService } from '@azure/msal-angular';
// import {FileDownloadpath } from "src/app/Shared/Model/offline/offline.model";
import { saveAs } from 'file-saver';
import { stringify } from 'querystring';
declare var $: any;

import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { EventType, EventMessage, AccountInfo, AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';





@Component({
    selector: 'app-offline',
    templateUrl: './offline.component.html',
    styleUrls: ['./offline.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OfflineComponent implements OnInit {
  hasData: boolean = false;
  DataAvaialble: boolean = true;
  CompanyTitle:string="GenWizard";
  UserName!:string;
  loading: boolean = true;
  route!: string;
  userid!: string;
  projectId!: string;
  appType!: string;
  dataSource!: any;
  offlineReportData!: any;
  displayedColumns!: string[];
  offinelst!: Offline[];
  offlineListMatTabDataSource = new MatTableDataSource<Offline>(this.offinelst);
  filepath!: FileDownloadpath;
  offlineURL!:string;
  offlineName!:string;
  progresspercent!:string;
  filedownload = {status: '', progressPercent: ''};
  showFileDownloadInfo:boolean=false;
  showalertMsg: boolean = false;
  alertMsg!: string;
  alertmsgClass!: string;

  isIframe = false;
  private readonly _destroying$ = new Subject<void>();

  loginDisplay = false;

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  showPortalUI!: boolean;

  constructor(
    private _offlineService: OfflineService,
    private _configLoaderService: ConfigLoaderService,
    private _Actrouter: ActivatedRoute,
    private _location: Location,
    private _router: Router,
    private authservice: AuthService,
    private http: HttpClient,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
  
  ) {
    this.filepath = new FileDownloadpath();
    console.log(this._Actrouter)
    this._Actrouter.queryParams.subscribe(params => {
      this.projectId = params['pid'];
      this.appType = params['app'];
    });

  }

  ngOnInit(): void {
    this.showPortalUI=true

     console.log('hereh222')
    // this.isIframe = window !== window.parent && !window.opener;
    // if (ConfigLoaderService.settings.env.name == "DEVELOPMENT") {
    //   this.UserName = ConfigLoaderService.settings.DevValues.userName;
    // }
    // else 
    //  {
    //     this.authservice.initializeAuth();
    //     this.msalBroadcastService.inProgress$
    //     .pipe(
    //       filter((status: InteractionStatus) => status === InteractionStatus.None)
    //     )
    //     .subscribe(() => {
    //       this.setLoginDisplay();
    //       this.authservice.checkAndSetActiveAccount();
    //     });

    //     this.msalBroadcastService.msalSubject$
    //     .pipe(
    //       filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
    //       takeUntil(this._destroying$)
    //     )
    //     .subscribe((result: EventMessage) => {
    //       const payload = result.payload as AuthenticationResult;
    //       this.msalService.instance.setActiveAccount(payload.account);
    //       console.log(payload)
    //     });

    //   this.msalBroadcastService.msalSubject$
    //     .pipe(
    //       filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_FAILURE || msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE),
    //       takeUntil(this._destroying$)
    //     )
    //     .subscribe((result: EventMessage) => {
    //       console.log(result)
    //       // Add your auth error handling logic here
    //     });
    
    //   //const account = this.getAccount();      
       this.UserName =  ConfigLoaderService.settings.AppSettings.userId;
         
    //  // ConfigLoaderService.settings.AppSettings.userId=this.UserName;

    //  }
     
     
    
    
   
    const tempval=sessionStorage.getItem("offline");
    const tempval1=(sessionStorage.getItem("offline")?.split("&")[0]);
    const tempval2=(tempval1?.split("=")[1]);
    console.log(ConfigLoaderService.settings.AppSettings.userId)
   
    this.getofflineReport(this.UserName,tempval2!);

  }

  setLoginDisplay() {
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
    if (this.loginDisplay) {
      this.authservice.getAccount();
    
    }
  }
  // getAccount() {
  //   return this.msalService.getAccount();

  // } 

  ngAfterViewInit() {


  }

  getofflineReport(userId: string, projectId: string) {

    this._offlineService.getOfflineReportonUserProject(userId,projectId)
      .subscribe(
        data => {
          console.log(data)
         
          this.offinelst = data;        
         
          if (!this.isEmpty(data)) {
  
            this.loading=false;
          this.offlineListMatTabDataSource.data = this.offinelst
          this.offlineListMatTabDataSource.sort = this.sort;
          this.offlineListMatTabDataSource.paginator = this.paginator;
          this.hasData = true;
          this.displayedColumns = Object.keys(data[0]);
          }
          else{
            this.loading=false;
            this.DataAvaialble = false; 
          }
       

        },
        error => {
          
          this.DataAvaialble = false;
          this.loading=false;
          this.hasData=false;
        }

      )

  }

  downloadFile(linkName:string) {  
    
    this.loading=true;
     var tmp = linkName.split("\\");
   
     this.filepath.Filepath = linkName
     this.filepath.Filename =tmp[4].toString();
   

    this._offlineService.getFile(this.filepath).subscribe(
      event => {
     
        var message= this.getStatusMessage(event,linkName)
            
        if(message.toLowerCase()=="done"){
          this.filedownload.progressPercent="100";
          $("#filedownloadsuccess").toast("show");
       this.alertmsgClass = 'alert alert-success';
       this.alertMsg = "File Downloaded Successfully.";      
         
           this.showalertMsg = true;
           this.showFileDownloadInfo=false;
           this.loading=false;
        }
      }

    )

    
     
  }

  generateDownload(data: Blob, linkName: string) {
    saveAs(data, this.filepath.Filename); // from file-saver library   
   
   
   
  }

  getStatusMessage(event:any,linkName:string){
    let status;

    switch(event.type){
      case HttpEventType.Sent:
       

      case HttpEventType.DownloadProgress:
        status = Math.round(100 * event.loaded / event.total);
       this.filedownload.status="InProgress"
       this.filedownload.progressPercent=status.toString();
       this.showFileDownloadInfo=true;
       $("#filedownloadsuccess").toast("show");
       this.alertmsgClass = 'alert alert-success';
       this.alertMsg = "File Download is InProgress.";
       this.showalertMsg = true;
        return 'Files are '+status+'% downloaded'; 


      case HttpEventType.Response:
       
         this.generateDownload(event.body!,linkName)
        
        return 'Done';

      default:
        return 'Something went wrong'
    }
  }



  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.offlineListMatTabDataSource.filter = filterValue.trim().toLowerCase();
  }

  logOut() {
    this.msalService.logoutRedirect();
  }

   isEmpty(obj:any) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }


}


